import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ path, title, className = "", label = "Share", testId = "share-button" }) => {
  const share = async (e) => {
    e.stopPropagation();
    const url = `${window.location.origin}${path}`;
    try {
      if (navigator.share) await navigator.share({ title, text: `${title} on NEW WAVE`, url });
      else { await navigator.clipboard.writeText(url); toast.success("Link copied"); }
    } catch (err) {
      if (err?.name !== "AbortError") toast.error("Could not share this link");
    }
  };
  return (
    <button data-testid={testId} onClick={share} aria-label="Share" className={className}>
      <Share2 className="h-5 w-5" /> {label && <span>{label}</span>}
    </button>
  );
};
